const styles = {
	tableRow: {
		borderBottom: "solid #9acedf 1px",
	},
	tableLastRow: {
		borderBottom: "solid #9acedf 2px",
		borderLeft: "solid #9acedf 1px",
		borderRight: "solid #9acedf 1px",
	},
	tableHead: {
		height: 24,
		backgroundColor: "#4aacc6",
		color: "white",
		borderLeft: "solid #9acedf 1px",
		borderRight: "solid #9acedf 1px",
	},
	tableHeading: {
		textAlign: "center",
	},
	tableNumbering: {
		width: 32,
		paddingLeft: 5,
		fontSize: 15,
		fontWeight: "bold",
		borderLeft: "solid #9acedf 1px",
	},
	traitName: {
		fontSize: 15,
		color: "black",
		borderLeft: "solid #9acedf 1px",
		paddingLeft: 8,
	},
	traitPerformance: {
		textAlign: "center",
		borderLeft: "solid #9acedf 1px",
		borderRight: "solid #9acedf 1px",
	},
	traitComments: {
		fontSize: 15,
		color: "black",
		borderRight: "solid #9acedf 1px",
		paddingLeft: 8,
		paddingRight: 8,
	},
	totalScore: {
		fontWeight: "bold",
		fontSize: 15,
		borderLeft: "solid #9acedf 1px",
		textAlign: "center",
	},
	totalPerformance: {
		textAlign: "center",
		borderLeft: "solid #9acedf 1px",
		borderRight: "solid #9acedf 1px",
	},
	learningObjectiveNameHeader: {
		width: "80%",
	},
	learningObjectivePerformanceHeader: {
		width: "20%",
		textAlign: "center",
		lineHeight: 1,
		borderLeft: "solid white 1px",
	},
	learningObjectiveName: {
		width: "80%",
		borderLeft: "solid #9acedf 1px",
		borderRight: "solid #9acedf 1px",
		paddingLeft: 5,
		paddingRight: 5,
	},
	learningObjectivePerformance: {
		width: "20%",
		borderRight: "solid #9acedf 1px",
		paddingLeft: 5,
		paddingRight: 5,
		textAlign: "center",
	},
	classQuestionHeader: {
		width: "100%",
	},
	classQuestion: {
		width: "50%",
		borderLeft: "solid #9acedf 1px",
		borderRight: "solid #9acedf 1px",
		paddingLeft: 5,
		paddingRight: 5,
	},
	classQuestionAnswer: {
		width: "50%",
		borderRight: "solid #9acedf 1px",
		paddingLeft: 5,
		paddingRight: 5,
		textAlign: "center",
	},
};

export default styles;
